/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesPursesApplicationPurseBreakdownsCalculatePurseProjectionPurseProjectionResponse } from '../model/modulesPursesApplicationPurseBreakdownsCalculatePurseProjectionPurseProjectionResponse';
import { ModulesPursesApplicationPurseBreakdownsGetTournamentLeaderboardForPurseTournamentLeaderboardRowResponse } from '../model/modulesPursesApplicationPurseBreakdownsGetTournamentLeaderboardForPurseTournamentLeaderboardRowResponse';
import { ModulesPursesApplicationPurseBreakdownsImportPurseBreakdownFromXmlImportPurseBreakdownFromXmlResponse } from '../model/modulesPursesApplicationPurseBreakdownsImportPurseBreakdownFromXmlImportPurseBreakdownFromXmlResponse';
import { ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse } from '../model/modulesPursesApplicationPurseBreakdownsPurseBreakdownResponse';
import { ModulesPursesApplicationPurseBreakdownsSavePlayerPurseAssignmentsSavePlayerPurseAssignmentsRequest } from '../model/modulesPursesApplicationPurseBreakdownsSavePlayerPurseAssignmentsSavePlayerPurseAssignmentsRequest';
import { ModulesPursesApplicationPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutResponse } from '../model/modulesPursesApplicationPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutResponse';
import { ModulesPursesEndpointsContractsPurseBreakdownsCreatePurseBreakdownRequest } from '../model/modulesPursesEndpointsContractsPurseBreakdownsCreatePurseBreakdownRequest';
import { ModulesPursesEndpointsContractsPurseBreakdownsUpdatePurseBreakdownRequestModel } from '../model/modulesPursesEndpointsContractsPurseBreakdownsUpdatePurseBreakdownRequestModel';
import { ModulesPursesEndpointsPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutBody } from '../model/modulesPursesEndpointsPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PursesServiceInterface }                            from './purses.serviceInterface';


@Injectable()
export class PursesService implements PursesServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Recalculates purse projections based on current tournament leaderboard.
     * Recalculates projected purse payouts for all eligible players based on current standings, handling ties, amateur status, and cut line logic.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public calculatePurseProjectionEndpoint(id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPursesApplicationPurseBreakdownsCalculatePurseProjectionPurseProjectionResponse>>;
    public calculatePurseProjectionEndpoint(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPursesApplicationPurseBreakdownsCalculatePurseProjectionPurseProjectionResponse>>>;
    public calculatePurseProjectionEndpoint(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPursesApplicationPurseBreakdownsCalculatePurseProjectionPurseProjectionResponse>>>;
    public calculatePurseProjectionEndpoint(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling calculatePurseProjectionEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPursesApplicationPurseBreakdownsCalculatePurseProjectionPurseProjectionResponse>>('put',`${this.basePath}/tournaments/${encodeURIComponent(String(id))}/purse-breakdown/calculate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PurseBreakdown.
     * Gets a PurseBreakdown using the PurseBreakdown identifier.
     * @param purseBreakdownId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPurseBreakdownByIdEndpoint(purseBreakdownId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>;
    public getPurseBreakdownByIdEndpoint(purseBreakdownId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>;
    public getPurseBreakdownByIdEndpoint(purseBreakdownId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>;
    public getPurseBreakdownByIdEndpoint(purseBreakdownId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (purseBreakdownId === null || purseBreakdownId === undefined) {
            throw new Error('Required parameter purseBreakdownId was null or undefined when calling getPurseBreakdownByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>('get',`${this.basePath}/purseBreakdowns/${encodeURIComponent(String(purseBreakdownId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Purse Breakdown by Tournament ID.
     * Gets a Purse Breakdown using the Tournament identifier.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPurseBreakdownByTournamentIdEndpoint(id: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>;
    public getPurseBreakdownByTournamentIdEndpoint(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>;
    public getPurseBreakdownByTournamentIdEndpoint(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>;
    public getPurseBreakdownByTournamentIdEndpoint(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPurseBreakdownByTournamentIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(id))}/purse-breakdown`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PurseBreakdowns.
     * Gets all PurseBreakdowns.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPurseBreakdownsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>;
    public getPurseBreakdownsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>>;
    public getPurseBreakdownsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>>;
    public getPurseBreakdownsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPursesApplicationPurseBreakdownsPurseBreakdownResponse>>('get',`${this.basePath}/purseBreakdowns`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the tournament leaderboard for purse projection calculations.
     * Gets the current tournament leaderboard with player standings, amateur status, and completion status needed for projecting purse payouts.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentLeaderboardForPurseEndpoint(id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPursesApplicationPurseBreakdownsGetTournamentLeaderboardForPurseTournamentLeaderboardRowResponse>>;
    public getTournamentLeaderboardForPurseEndpoint(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPursesApplicationPurseBreakdownsGetTournamentLeaderboardForPurseTournamentLeaderboardRowResponse>>>;
    public getTournamentLeaderboardForPurseEndpoint(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPursesApplicationPurseBreakdownsGetTournamentLeaderboardForPurseTournamentLeaderboardRowResponse>>>;
    public getTournamentLeaderboardForPurseEndpoint(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTournamentLeaderboardForPurseEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPursesApplicationPurseBreakdownsGetTournamentLeaderboardForPurseTournamentLeaderboardRowResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(id))}/leaderboard`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PurseBreakdown.
     * Creates a PurseBreakdown based on the CreatePurseBreakdownRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purseBreakdownsPost(body?: ModulesPursesEndpointsContractsPurseBreakdownsCreatePurseBreakdownRequest, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public purseBreakdownsPost(body?: ModulesPursesEndpointsContractsPurseBreakdownsCreatePurseBreakdownRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public purseBreakdownsPost(body?: ModulesPursesEndpointsContractsPurseBreakdownsCreatePurseBreakdownRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public purseBreakdownsPost(body?: ModulesPursesEndpointsContractsPurseBreakdownsCreatePurseBreakdownRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/purseBreakdowns`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PurseBreakdown.
     * Removes a PurseBreakdown using the PurseBreakdown identifier.
     * @param purseBreakdownId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purseBreakdownsPurseBreakdownIdDelete(purseBreakdownId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public purseBreakdownsPurseBreakdownIdDelete(purseBreakdownId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public purseBreakdownsPurseBreakdownIdDelete(purseBreakdownId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public purseBreakdownsPurseBreakdownIdDelete(purseBreakdownId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (purseBreakdownId === null || purseBreakdownId === undefined) {
            throw new Error('Required parameter purseBreakdownId was null or undefined when calling purseBreakdownsPurseBreakdownIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/purseBreakdowns/${encodeURIComponent(String(purseBreakdownId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PurseBreakdown.
     * Updates a PurseBreakdown based on the PurseBreakdown idenfier and UpdatePurseBreakdownRequest.
     * @param purseBreakdownId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purseBreakdownsPurseBreakdownIdPut(purseBreakdownId: string, body?: ModulesPursesEndpointsContractsPurseBreakdownsUpdatePurseBreakdownRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public purseBreakdownsPurseBreakdownIdPut(purseBreakdownId: string, body?: ModulesPursesEndpointsContractsPurseBreakdownsUpdatePurseBreakdownRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public purseBreakdownsPurseBreakdownIdPut(purseBreakdownId: string, body?: ModulesPursesEndpointsContractsPurseBreakdownsUpdatePurseBreakdownRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public purseBreakdownsPurseBreakdownIdPut(purseBreakdownId: string, body?: ModulesPursesEndpointsContractsPurseBreakdownsUpdatePurseBreakdownRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (purseBreakdownId === null || purseBreakdownId === undefined) {
            throw new Error('Required parameter purseBreakdownId was null or undefined when calling purseBreakdownsPurseBreakdownIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/purseBreakdowns/${encodeURIComponent(String(purseBreakdownId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Save player purse assignments
     * Saves the assigned purse payouts to tournament players with validation (15% variance, amateur $0 enforcement)
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purseBreakdownsSavePlayerAssignments(id: string, body?: ModulesPursesApplicationPurseBreakdownsSavePlayerPurseAssignmentsSavePlayerPurseAssignmentsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public purseBreakdownsSavePlayerAssignments(id: string, body?: ModulesPursesApplicationPurseBreakdownsSavePlayerPurseAssignmentsSavePlayerPurseAssignmentsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public purseBreakdownsSavePlayerAssignments(id: string, body?: ModulesPursesApplicationPurseBreakdownsSavePlayerPurseAssignmentsSavePlayerPurseAssignmentsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public purseBreakdownsSavePlayerAssignments(id: string, body?: ModulesPursesApplicationPurseBreakdownsSavePlayerPurseAssignmentsSavePlayerPurseAssignmentsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purseBreakdownsSavePlayerAssignments.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(id))}/purse-breakdown/assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Imports a PurseBreakdown from XML.
     * Imports a PurseBreakdown for a tournament using raw XML content.
     * @param id 
     * @param xmlContent 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsIdPurseBreakdownImportPost(id: string, xmlContent?: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPursesApplicationPurseBreakdownsImportPurseBreakdownFromXmlImportPurseBreakdownFromXmlResponse>;
    public tournamentsIdPurseBreakdownImportPost(id: string, xmlContent?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPursesApplicationPurseBreakdownsImportPurseBreakdownFromXmlImportPurseBreakdownFromXmlResponse>>;
    public tournamentsIdPurseBreakdownImportPost(id: string, xmlContent?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPursesApplicationPurseBreakdownsImportPurseBreakdownFromXmlImportPurseBreakdownFromXmlResponse>>;
    public tournamentsIdPurseBreakdownImportPost(id: string, xmlContent?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling tournamentsIdPurseBreakdownImportPost.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (xmlContent !== undefined && xmlContent !== null) {
            queryParameters = queryParameters.set('XmlContent', <any>xmlContent);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPursesApplicationPurseBreakdownsImportPurseBreakdownFromXmlImportPurseBreakdownFromXmlResponse>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(id))}/purse-breakdown/import`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a single tournament player payout.
     * Updates the assigned payout for a single tournament player and returns the refreshed payout details.
     * @param body 
     * @param id 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePlayerPayoutEndpoint(body: ModulesPursesEndpointsPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutBody, id: string, playerId: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesPursesApplicationPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutResponse>;
    public updatePlayerPayoutEndpoint(body: ModulesPursesEndpointsPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutBody, id: string, playerId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPursesApplicationPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutResponse>>;
    public updatePlayerPayoutEndpoint(body: ModulesPursesEndpointsPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutBody, id: string, playerId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPursesApplicationPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutResponse>>;
    public updatePlayerPayoutEndpoint(body: ModulesPursesEndpointsPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutBody, id: string, playerId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updatePlayerPayoutEndpoint.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updatePlayerPayoutEndpoint.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling updatePlayerPayoutEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ModulesPursesApplicationPurseBreakdownsUpdatePlayerPayoutUpdatePlayerPayoutResponse>('put',`${this.basePath}/tournaments/${encodeURIComponent(String(id))}/players/${encodeURIComponent(String(playerId))}/payout`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
